module.exports = __webpack_public_path__ + "static/img/haitaojingxuan.f07d3e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/haitaojingxuan.png
// module id = XEjv
// module chunks = 1